
export enum SaleStatsSnapshotWsEventResponseDtoEvent {
  SaleStatsSnapshot= 'SaleStatsSnapshot',

}